import { Button, Card, Col, Form, Row, Select, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { db } from "../../../../firebase";
import { bankAccounts } from "../../../../utils/NewPropertyHelper";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { toast } from "react-hot-toast";

const BankAccounts = ({ dataId, companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [accounts, setAccounts] = useState([
    { id: uuidv4(), cashGLAccount: "", bankAccount: "" },
  ]);

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const filteredTenant = fetchedData.find((item) => item.id === dataId);
          setAccounts(
            filteredTenant?.bankAccounts?.length >= 1
              ? filteredTenant?.bankAccounts
              : [{ id: uuidv4(), cashGLAccount: "", bankAccount: "" }]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, isEditActive]);

  const handleChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const addAccount = () => {
    const newAccount = {
      id: uuidv4(),
      cashGLAccount: "",
      bankAccount: "",
    };
    setAccounts([...accounts, newAccount]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => item.id !== id);
    setAccounts(updatedAccounts);
  };

  const onFinish = async () => {
    const propertyDocRef = doc(
      db,
      "companies",
      companyName,
      "properties",
      dataId
    );

    const filteredBanlAccounts = accounts.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const bAccounts = {
      bankAccounts: filteredBanlAccounts,
    };

    try {
      await updateDoc(propertyDocRef, bAccounts);
      toast.success("Bank Accounts Updated Successfully..", 3);
      setIsEditActive(false);
    } catch (error) {
      console.error("not updated:", error);
      toast.error("Failed to update bankAccounts", 3);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const tableHeader = [
    {
      title: "Cash GL Account",
      dataIndex: "GlAccount",
      key: "GlAccount",
      render: (_, record) => <p>{record.cashGLAccount}</p>,
    },
    {
      title: "Bank Account",
      dataIndex: "bankAccount",
      key: "BankAccount",
      render: (_, record) => <p>{record.bankAccount}</p>,
    },
    {
      title: "Payments Enabled",
      dataIndex: "paymentsEnabled",
      key: "paymentsEnabled",
      render: () => (
        <span>
          <Tag color="success">Enable</Tag>
        </span>
      ),
    },
  ];

  return (
    <div>
      <Card
        title="Bank Accounts"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          colon={false}
        >
          {isEditActive ? (
            <ul>
              <Row style={{ marginBottom: 12 }}>
                <Col className="tableHead" span={12}>
                  <p>Cash GL Account</p>
                </Col>
                <Col className="tableHead" span={11}>
                  <p>Bank Account</p>
                </Col>

                <Col span={1}></Col>
              </Row>
              {accounts?.map((item) => (
                <li key={item.id}>
                  <Row>
                    <Col span={12}>
                      <Form.Item label="">
                        <Select
                          showSearch
                          style={{ width: "100%" }}
                          options={bankAccounts}
                          value={item.cashGLAccount}
                          onChange={(value) =>
                            handleChange(value, "cashGLAccount", item.id)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item>
                        <Select
                          showSearch
                          style={{ width: "100%" }}
                          options={bankAccounts}
                          value={item.bankAccount}
                          onChange={(value) =>
                            handleChange(value, "bankAccount", item.id)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1}>
                      {accounts.length > 1 ? (
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            removeAccount(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                </li>
              ))}
              <Form.Item label="">
                <Button
                  className="addPropertyGroupButton"
                  type="primary"
                  onClick={addAccount}
                  size={"small"}
                  icon={<i className="fa-solid fa-circle-plus"></i>}
                >
                  Add Another Account
                </Button>
              </Form.Item>
            </ul>
          ) : (
            <Table
              columns={tableHeader}
              dataSource={accounts}
              size="small"
              pagination={false}
            />
          )}
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit">
                  save
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default BankAccounts;
